'use strict';

var GridToolbarConfigurationFlightAssignmentDirective = function GridToolbarConfigurationFlightAssignmentDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-configuration-flight-assignment.html'),
    controller: 'GridToolbarConfigurationFlightAssignmentController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarConfigurationFlightAssignmentDirective.$inject = [];
module.exports = GridToolbarConfigurationFlightAssignmentDirective;